import { takeLatest, put } from 'redux-saga/effects';
import actionCreator from 'utils/actionCreator';
import axios from 'utils/axios';
import { productsActions } from './products';

/**
 * Action Types
 */
export const productsReadActionTypes = {
    REQUEST: '@app/products/read/REQUEST',
    FAILURE: '@app/products/read/FAILURE',
    SUCCESS: '@app/products/read/SUCCESS',
}

/**
 * Redux Actions
 */
export const productsReadActions = {
    request: actionCreator(productsReadActionTypes.REQUEST),
    success: actionCreator(productsReadActionTypes.SUCCESS),
    failure: actionCreator(productsReadActionTypes.FAILURE)
};

/**
 * Saga Functions
 */
export const sagas = {
    *request({ payload, resolve, reject }) {
        try {
            const res = yield axios.get('/products', { params: payload });

            yield put(productsActions.read({ products: res.data.results, total: res.data.total }));
            yield put(productsReadActions.success());

            resolve(res.data);
        } catch (err) {
            yield put(productsReadActions.failure(err.response.data.errors));
            reject(err);
        }
    }
}

/**
 * Saga Watchers
 */
export const productsReadWatchers = function* () {
    yield takeLatest(productsReadActionTypes.REQUEST, sagas.request)
}
